<template>
	<div>
		<page>
			<zui-header>
				<logo type="xiaoyanyun" href="/"></logo>
				<h4 class="zui-logo-text">
					|&nbsp;&nbsp;数据标注+IP寻址+安全可信
					<br />|&nbsp;&nbsp;数字化服务提供商
				</h4>
				<div class="zui-rightcol" @click="openMenu" style="color: rgb(57 94 194);">◄目录►</div>
                <drop-list :config="configData" :wcindex="windex" ref="droplist"></drop-list>
				<zui-button :class="content == 'theory' ? 'active': '' "
					@click="onButtonClick('theory')">理论创新</zui-button>
				<zui-button :class="content == 'legal' ? 'active': '' "
					@click="onButtonClick('legal')">数字中国</zui-button>
				<zui-button :class="content == 'tech' ? 'active': '' " @click="onButtonClick('tech')">科技创新</zui-button>
				<zui-button :class="content == 'plan' ? 'active': '' " @click="onButtonClick('plan')">资质荣誉</zui-button>
				<zui-button :class="content == 'case' ? 'active': '' " @click="onButtonClick('case')">成功案例</zui-button>
				<zui-button :class="content == 'service' ? 'active': '' "
					@click="onButtonClick('service')">服务模式</zui-button>
				<zui-button :class="content == 'home' ? 'active': '' " @click="onButtonClick('home')">首页</zui-button>
			</zui-header>
			<router-view></router-view>
			<zui-footer />
		</page>
	</div>
</template>
<script>
	import '../views/less/home-page.less'
	import Logo from './Logo'
	import Page from './Page'
	import ZuiHeader from './Header'
	import ZuiFooter from './Footer'
	import ZuiButton from './Button'
	import Util from '../Util'
	import DropList from 'vue-droplist'
	export default {
		components: {
			Page,
			Logo,
			ZuiHeader,
			ZuiFooter,
			ZuiButton,
			DropList
		},
		data() {
			return {
				carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2,
				configData: {
					position: { // 设置显示位置，position
						top: '60px',
						right: '15px',
						bottom: '',
						left: ''
					},
					width: '40%', // 设置宽度
					list: [ // 设置下拉列表数据和对应的点击事件
						{
							text: '首页',
							action: this.gohome,
							index: 1
						},
						{
							text: '服务模式',
							action: this.goservice,
							index: 2
						},
						{
							text: '成功案例',
							action: this.gocase,
							index: 3
						},
						{
							text: '资质荣誉',
							action: this.goplan,
							index: 4
						},
						{
							text: '科技创新',
							action: this.gotech,
							index: 5
						},
						{
							text: '合法合规',
							action: this.golegal,
							index: 6
						},
						{
							text: '理论创新',
							action: this.gotheory,
							index: 7
						}
					]
				},
				isActive: false
			}
		},
		watch: {
			'$route': function(to, from) {
				switch (to.path) {
					case '/':
						this.content = 'home';
						this.windex = 1;
						break;
					case '/service':
						this.content = 'service';
						this.windex = 2;
						break;
					case '/plan':
						this.content = 'plan';
						this.windex = 4;
						break;
					case '/case1':
						this.content = 'case';
						this.windex = 3;
						break;
					case '/link':
						this.content = 'link';
						break;
					case '/tech':
						this.content = 'tech';
						this.windex = 5;
						break;
					case '/legal':
						this.content = 'legal';
						this.windex = 6;
						break;
					case '/theory':
						this.content = 'theory';
						this.windex = 7;
						break;
				}
			}
		},
		methods: {
			onButtonClick: function(e) {
				if (e == "home") {
					this.$router.push({
						path: '/'
					})
				} else if (e == "service") {
					this.$router.push({
						path: '/service'
					})
					this.isActive = true
					this.content = "service"
				} else if (e == "plan") {
					this.$router.push({
						path: '/plan'
					})
					this.isActive = true
					this.content = "plan"
				} else if (e == "case") {
					this.$router.push({
						path: '/case1'
					})
					this.isActive = true
					this.content = "case"
				} else if (e == "link") {
					this.$router.push({
						path: '/link'
					})
					this.isActive = true
					this.content = "link"
				} else if (e == "tech") {
					this.$router.push({
						path: '/tech'
					})
					this.isActive = true
					this.content = "tech"
				} else if (e == "legal") {
					this.$router.push({
						path: '/legal'
					})
					this.isActive = true
					this.content = "legal"
				} else if (e == "theory") {
					this.$router.push({
						path: '/theory'
					})
					this.isActive = true
					this.content = "theory"
				} else {
					this.$router.push({
						path: '/'
					})
				}
			},
			openMenu: function() {
				this.$refs.droplist.show()
			},
			gohome: function() {
				this.windex = 1;
				this.$router.push({
					path: '/'
				})
			},
			goservice: function() {
				this.windex = 2;
				this.$router.push({
					path: '/service'
				})
			},
			gocase: function() {
				this.windex = 3;
				this.$router.push({
					path: '/case1'
				})
			},
			goplan: function() {
				this.windex = 4;
				this.$router.push({
					path: '/plan'
				})
			},
			gotech: function() {
				this.windex = 5;
				this.$router.push({
					path: '/tech'
				})
			},
			golegal: function() {
				this.windex = 6;
				this.$router.push({
					path: '/legal'
				})
			},
			gotheory: function() {
				this.windex = 7;
				this.$router.push({
					path: '/theory'
				})
			},
			golink: function() {
				this.$router.push({
					path: '/link'
				})
			},
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/App.vue